module.exports = __webpack_public_path__ + "img/resmed-logo-color.eac611ee.png";